export enum OrderProposalType {
  ENGINE = 'engine',
  MANUAL = 'manual',
}
